import MouseEventArgs from './MouseEventArgs';
import Editor from './Editor';

export default class Tool {

    private _editor: Editor;
    private _name: string

    public get editor(): Editor {
        return this._editor;
    }

    public get name(): string {
        return this._name;
    }

    public constructor(editor: Editor, name: string) {
        this._editor = editor;
        this._name = name;
    }

    public handleMouseDown(arg: MouseEventArgs): boolean {
        return false;
    }

    public handleMouseMove(arg: MouseEventArgs): boolean {
        return false;
    }

    public handleMouseUp(arg: MouseEventArgs): boolean {
        return false;
    }

    public handleMouseWheel(arg: MouseEventArgs): boolean {
        return false;
    }

    public handleDelete(): boolean {
        return false;
    }

    public draw(context: CanvasRenderingContext2D) {

    }

    public finalize() {
        
    }

    public initialize() {
        
    }

    
}